'use strict';

angular.module('mobile-apps')
	.service('EntryStatus', ['SweetAlert', 'Teams', 'AvailableLanguages', 'TagMain', 'LanguageEntries', 'Utilities', '$modal', '$rootScope', '$timeout', function(SweetAlert, Teams, AvailableLanguages, TagMain, LanguageEntries, Utilities, $modal, $rootScope, $timeout) {

		var statusInformation = {
			1: {
				name: 'Accepted',
				icon: 'fa fa-check',
				color: '#008000'
			},
			2: {
				name: 'Needs Review',
				color: '#45880a'
			},
			3: {
				name: 'Needs Translation',
				color: '#e3cc85'
			},
			4: {
				name: 'Rejected',
				color: '#d7272f'
			},
            5: {
			    name: 'In Order',
                color: '#23368b'
            }
		};


        return {
			statusInformation: statusInformation,
			openModal: function(appId, languageId, groupId, entryKeys, entries, tags, tagCategories) {

				if (!angular.isArray(entryKeys) || entryKeys.length === 0) {
					// If we did not get an array of ids we do not display anything
					return;
				}

				return $modal.open({
					templateUrl: 'modules/mobile-apps/views/entry-status-modal.client.view.html',
					controller: ['$scope', '$modalInstance', 'SweetAlert', 'EntryMain', 'MobileAppEntryStatus', 'entryKeys', function ($scope, $modalInstance, SweetAlert, EntryMain, MobileAppEntryStatus, entryKeys) {

						var commentGotReset = false;
						var initialComment = null;

						$scope.errorMessage = null;
						$scope.status = null;
						$scope.comment = '';
						$scope.applyAllLanguages = false;
						$scope.users = [];
						
						$scope.applySpecificLanguages = false;
						$scope.languages = [];
						$scope.availableLanguages = AvailableLanguages.get();
						$scope.selectedLanguages = [];

						$scope.mobileAppId = appId;
						$scope.applyTags = false;
						$scope.selectedKeys = entryKeys;
						$scope.entries = entries || [];
						$scope.tags = tags;
						$scope.tagCategories = tagCategories;
						$scope.extendedFunctions = {};

						// Query the team-members
						EntryMain._fetchMobileApp(appId, false, function(err, data) {
							Teams.get({
								teamId: data.team._id
							},
							function success (response) {
								response.members.forEach(function(member) {
									$scope.users.push({
										id: member.user._id,
										displayName: member.user.displayName,
										checkName: member.user.displayName.toLowerCase()
									});
								});

								Object.keys(EntryMain.languages).forEach(function(key){
									$scope.languages.push({_id: EntryMain.languages[key]._id, iso: EntryMain.languages[key].name, name: $scope.availableLanguages[EntryMain.languages[key].name]});
								});
							}, function failure (errResponse) {
									console.log(errResponse);
							});

						});

						$scope.statusInformation = statusInformation;

						// Defines in which order the status-buttons should
						// be displayed
						$scope.statusInformationSort = [4, 3, 2, 1];

						$scope.changeLogQuery = {
							languageId: languageId,
							entryKeys: entryKeys
						};

						$scope.selectStatus = function(statusId) {
							$scope.status = statusId;
							if (initialComment === $scope.comment && commentGotReset === false) {
								$scope.comment = '';
								commentGotReset = true;
							}
						};

						$scope.save = function() {
							$scope.errorMessage = '';

							if (!$scope.status) {
								$scope.errorMessage = 'Please set a status!';
								return;
							}

							var languagesForStatus = [];
							if($scope.applySpecificLanguages){
								Object.keys($scope.selectedLanguages).forEach(function(iso){
									if($scope.selectedLanguages[iso] === true){
										languagesForStatus.push($scope.languages.find(function(language){
											return language.iso === iso;
										}));
									}
								});
							}

							if ($scope.applyTags) {
								$scope.extendedFunctions.saveTags();
							}

							var entryValues = [];
							if(entryKeys && entryKeys.length) {
                                entryValues = $scope.entries.filter(function (entry) {
                                    return entryKeys.includes(entry.key);
                                });
                            }

							$timeout(() => {
								Utilities.loadingUiModal('open');	
							}, 33);

							MobileAppEntryStatus.setStatus({
								mobileAppId: appId,
								languageId: languageId,
								groupId: groupId,
								entryKeys: entryKeys,
                                entryValues: entryValues,
								status: $scope.status,
								comment: $scope.comment,
								applyAllLanguages: $scope.applyAllLanguages,
								applySpecificLanguages: $scope.applySpecificLanguages,
								selectedLanguages: languagesForStatus
							}, function (data) {
								$timeout(() => {
									Utilities.loadingUiModal('close');	
								}, 33);
								// Update the data
								$rootScope.$broadcast('entriesChanged');

								$modalInstance.close();
							}, function (err) {
								$timeout(() => {
									Utilities.loadingUiModal('close');	
								}, 33);
								$timeout(function() {
									SweetAlert.swal(
										{
											title: 'Oops!',
											text: err.data.message,
											type: 'error',
											showCancelButton: false
										}
									);
								}, 50);
							});
						};

						$scope.handleSelectLanguagesClick = function(){
							$scope.applyAllLanguages = false;
						};

						$scope.handleSelectAllLanguagesClick = function(){
							$scope.applySpecificLanguages = false;
						};

						$scope.getProjectLanguages = function(){
							return $scope.languages;
						};

						$scope.toggleLanguageIntoStatus = function(iso){
							$scope.selectedLanguages[iso] = !$scope.selectedLanguages[iso];

							var anySelected = false;
							Object.keys($scope.selectedLanguages).forEach(function(language){
								if($scope.selectedLanguages[language] === true){
									anySelected = true;
								}
							});
							if(!anySelected){
								$scope.applySpecificLanguages = false;
								$scope.languages.forEach(function(language){
									$scope.selectedLanguages[language.iso] = false;
								});
							}
						};

						/**
						 * Returns array of currently selected entries
						*/
						$scope.getSelectedEntries = function() {
							var selectedEntries = [];
							$scope.entries.forEach(function (entry) {
								if (entry.selected === true) {
									selectedEntries.push(entry);
								}
							});

							if(!selectedEntries.length){
								selectedEntries = entries.filter(function(item){
									return item.key === entryKeys[0];
								});
							}

							return selectedEntries;
						};

						/**
						 * Updating selected tags from directive
						*/
						$scope.extendedFunctions.updateTagsPropsParent = function(applyTags){
							$scope.applyTags = applyTags;
						};

						$scope.close = function() {
							$modalInstance.close();
						};


						MobileAppEntryStatus.getStatus({
							mobileAppId: appId,
							languageId: languageId,
							groupId: groupId,
							entryKeys: entryKeys
						}, function (data) {
							$scope.status = data.status;
							$scope.comment = data.comment;
							initialComment = data.comment;
						}, function (err) {

							$timeout(function() {
								SweetAlert.swal(
									{
										title: 'Oops!',
										text: err.data.message,
										type: 'error',
										showCancelButton: false
									}
								);
							}, 50);

						});

					}],
					size: 'md',
					resolve: {
						entryKeys: function() {
							return entryKeys;
						}
					}
				});

			}
		};
    }
]);
